import {Pipe, PipeTransform} from "@angular/core";
import {ComparatorService} from "../../services/comparator-service";
import {LastRechtGrundstueckEntryMeta} from "../../../core/gb-api";

@Pipe({
  name: 'orderByLastrechtEntry'
})
export class OrderByLastrechtEntryPipe implements PipeTransform {

  public constructor(private comperatorService: ComparatorService) {
  }

  transform(array, ascending = true): Array<LastRechtGrundstueckEntryMeta> | any {
    if (ascending) {
      return Array.from(array).sort((item1: LastRechtGrundstueckEntryMeta, item2: LastRechtGrundstueckEntryMeta) => {
        return this.comperatorService.grundstueckComparator(item1.grundstueck, item2.grundstueck);
      });
    } else {
      return Array.from(array).sort((item1: LastRechtGrundstueckEntryMeta, item2: LastRechtGrundstueckEntryMeta) => {
        return this.comperatorService.grundstueckComparator(item1.grundstueck, item2.grundstueck);
      });
    }
  }

}
